import { connect } from "react-redux";

import { getSchoolIDList } from "state/teachers/selectors";

import EntityCarousel from "components/EntityCarousel";

/**
 * Allow swiping between schools' pages.
 */
export default connect(
  (state, { activeSchoolID }) => ({
    entityIDList: getSchoolIDList(state),
    activeEntityID: activeSchoolID
  })
)(EntityCarousel);



// WEBPACK FOOTER //
// ./src/components/teachers/SchoolCarousel.js